import { track_ga } from './firebase'

// 营销活动弹窗曝光
export const pagePopupShow = (params) => {
  track_ga('page_popup_show', params)
}
// 营销活动入口点击
export const pagePopupClick = (params) => {
  track_ga('page_popup_click', params)
}
